import { datadogRum } from '@datadog/browser-rum'
import { getAuth, signOut } from 'firebase/auth'
import logger from './logger'

export default async function logoutUser() {
  try {
    const auth = getAuth()
    await signOut(auth)
    datadogRum.clearUser()
    logger.info('Datadog cleared user session')
  } catch (error) {
    logger.error('failure to logoutUser', error)
  }
}
